// extracted by mini-css-extract-plugin
export default {"asyncSuggestion":"shared-module__asyncSuggestion--AXibl","stale":"shared-module__stale--R4Im6"};